import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';

const ENDPOINT = import.meta.env.DEV
  ? 'http://localhost:8080'
  : 'https://property-tax-api.yourwayhome.com';

export default function useGetReports() {
  const { isAuthenticated } = useAuth0();
  const token = window.localStorage.getItem('_token');

  return useQuery({
    queryKey: ['REPORTS'],
    queryFn: async () => {
      const response = await fetch(`${ENDPOINT}/api/v1/reports`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data.data;
    },
    enabled: isAuthenticated && !!token,
  });
}
